<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-salary
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
          @download-excel="onDownloadExcel"
        />
        <table-paginated-salary-base
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
        />
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        />
      </v-flex>
      <modal-loading :is-show="isTableLoading"/>

    </v-layout>
  </v-container>
</template>

<script>
/* constants */
import { PER_PAGE } from '@/constants/listing';
/* proxies */
import SalaryCleanerBaseProxy from '@/proxies/Salary/SalaryCleanerBaseProxy';
/* mixins */
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import paginationMixin from '@/mixins/listing/paginationMixin';
import downloadReport from '@/mixins/reports/downloadReport';
/* components */
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import FilterSalary from '@/components/listings/FilterSalary.vue';
import TablePaginatedSalaryBase from '@/components/listings/TablePaginatedSalaryBase.vue';
import PaginationListing from '@/components/listings/PaginationListing.vue';

export default {
  name: 'SalaryCleanersBase',
  mixins: [
    updatePageContentMixin,
    paginationMixin,
    defaultListingMixin,
    downloadReport,
  ],
  components: {
    ModalLoading,
    TablePaginatedSalaryBase,
    PaginationListing,
    FilterSalary,
  },
  data() {
    return {
      reportMethodName: 'salaryCleanerBaseListingReport',
      /* Page management */
      pageLoading: false,
      isTableLoading: false,
      fetchDataOnCreated: false,
      searchParams: {
        search: '',
        region: null,
        subscription: null,
        page: {
          number: 1,
          size: PER_PAGE,
        },
      },
    };
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new SalaryCleanerBaseProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          // eslint-disable-next-line no-param-reassign
          /* response.data.data.salary.data = CleanerTransformer.fetchCollection(
            response.data.data.cleaners.data,
          ); */
          this.paginatedObject = response.data.data.salary;
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>

<style scoped>

</style>
